// /assets/recharge-bridge.js
(() => {
  if (window.__rechargeBridgeInited) return;
  window.__rechargeBridgeInited = true;

  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const bust = () => `&_=${Date.now()}`;
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  let refreshPending = false;

  // ---------- Drawer helpers ----------
  const getDrawer = () =>
    document.getElementById('CartDrawer') || document.querySelector('cart-drawer');

  const getDrawerInner = (root = document) =>
    root.querySelector('[id^="CartDrawer-"]');

  const isDrawerOpen = (el) => {
    if (!el) return false;
    if (el.hasAttribute('hidden')) return false;
    return el.hasAttribute('open') || el.classList.contains('active');
  };

  const openDrawer = (el) => {
    if (!el) return;
    el.removeAttribute('hidden');
    el.setAttribute('open', '');
    el.classList.add('active');
    el.querySelector('.fixed-overlay')?.setAttribute('aria-expanded', 'true');
    el.querySelector('.drawer__close-btn')?.setAttribute('aria-expanded', 'true');
    document.dispatchEvent(new CustomEvent('cart-drawer:opened', { detail: { target: el } }));
  };

  // ---------- Refresh logic ----------
  async function refreshDrawerInner(ensureOpen) {
    try {
      const res = await fetch(`/?sections=${SECTIONS}${bust()}`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
          Expires: '0'
        }
      });
      if (!res.ok) return;
      const sections = await res.json();

      // Swap only the drawer inner so the drawer state persists
      if (sections['cart-drawer']) {
        const temp = document.createElement('div');
        temp.innerHTML = sections['cart-drawer'];
        const nextInner = getDrawerInner(temp);
        const curInner  = getDrawerInner(document);
        if (nextInner && curInner) {
          curInner.replaceWith(nextInner);
          document.dispatchEvent(
            new CustomEvent('shopify:section:load', {
              detail: { sectionId: getDrawer()?.dataset.sectionId, container: nextInner }
            })
          );
        }
      }

      // Update cart bubble/count if present
      if (sections['cart-icon-bubble']) {
        const t2 = document.createElement('div');
        t2.innerHTML = sections['cart-icon-bubble'];
        const nextBubble = t2.querySelector('[data-cart-icon-bubble], cart-count');
        const curBubble  = document.querySelector('[data-cart-icon-bubble], cart-count');
        if (nextBubble && curBubble) curBubble.replaceWith(nextBubble);
      }

      // Re-open if Recharge closed it and it was (or should be) open
      if (ensureOpen) {
        const drawer = getDrawer();
        if (!isDrawerOpen(drawer)) openDrawer(drawer);
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:refreshed'));
    } catch (e) {
      console.error('Cart drawer refresh failed:', e);
    }
  }

  function scheduleRefresh(forceOpen = false) {
    if (refreshPending) return;
    refreshPending = true;

    const drawer = getDrawer();
    const shouldBeOpen = forceOpen || isDrawerOpen(drawer);

    setTimeout(async () => {
      await sleep(60); // tiny buffer for app/cart writes to settle
      await refreshDrawerInner(shouldBeOpen);
      refreshPending = false;
    }, 60);
  }

  // ---------- Hooks ----------
  // Recharge signals (will no-op if not emitted)
  document.addEventListener('recharge:upsell:added',      () => scheduleRefresh(true));
  document.addEventListener('recharge:subscription:added', () => scheduleRefresh(true));
  document.addEventListener('recharge:drawer:accepted',    () => scheduleRefresh(true));
  document.addEventListener('recharge:cart:updated',       () => scheduleRefresh(true));

  // Fallback: intercept same-origin cart writes
  const _fetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _fetch.apply(this, args);
    try {
      const req = args[0];
      const url = typeof req === 'string' ? req : req?.url;
      const isSameOrigin =
        typeof url === 'string' &&
        (url.startsWith('/') || url.startsWith(location.origin));
      if (isSameOrigin && /\/cart\/(add|change)(\.js)?/.test(url)) {
        queueMicrotask(() => scheduleRefresh(true));
      }
    } catch (_) {}
    return res;
  };

  // Manual trigger if other code needs it
  document.addEventListener('cart:refresh', () => scheduleRefresh(true));
})();
